export const helpers = (props) => {
  let results = {};
  let fieldsEqual = [{ name: '_haslayout', value: 'true' }];

  if (!!props?.pageSection && props?.pageSection !== '') {
    fieldsEqual.push({
      name: 'pagesection',
      value: props?.pageSection,
    });
  }

  let noPagination = {
    index: props?.indexName,
    language: props?.language,
    fieldsEqual: fieldsEqual,
    after: `0`,
    first: props?.pageSize || 1,
  };

  let withPagination = {
    index: props?.indexName,
    language: props?.language,
    first: props?.pagination?.itemsPerPage || 1,
    fieldsEqual: fieldsEqual,
    after: `${!!props?.pagination?.currentPage && !!props?.pagination?.itemsPerPage
        ? `${props?.pagination?.itemsPerPage * (props?.pagination?.currentPage - 1)}`
        : ''
      }`,
  };

  if (props?.hasPagination) {
    results = withPagination; //in mobile results we dont have pagination so we remove the first and after
  } else {
    results = noPagination;
  }

  if (props?.keyword !== '') {
    results.keyword = `${props?.keyword}`;
  } else {
    results.keyword = '';
  }

  if (!!props?.facetOn && props?.facetOn !== '') {
    results.facetOn = [`${props?.facetOn}`];
  }
  //for the search suggestion in the input
  if (props?.getSearchSuggestions !== undefined) {
    props.getSearchSuggestions({
      variables: {
        ...results,
      },
    });
  }
  //when we click on the category to get the results related to the category
  if (props?.getSearchResults !== undefined) {
    props.getSearchResults({
      variables: {
        ...results,
      },
    });
  }
  if (props?.getSearchResultsWithoutSettingTotal !== undefined) {
    props.getSearchResultsWithoutSettingTotal({
      variables: {
        ...results,
      },
    });
  }
  //For search results and the left category list
  if (props?.setFilterVariable !== undefined) {
    props.setFilterVariable(results);
  }
};
export const getParam = () => {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });
  // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
  return params.keyword; // "some_value"
};
